import { LoaderCircle } from 'lucide-react';
export const Loading = ({ text }) => {
    return (
        <div className="text-center p-12">
            <LoaderCircle className="inline size-8 animate-spin text-rust" /><br />
            <div className="mt-4">Loading { text }</div>
        </div>
    );
}
